module.exports = __webpack_public_path__ + "static/media/doctorwithstethoscope .03b0c722.svg";